import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BasketItemComponentDef } from '@df/basket/view/basket-item.component.def';
import { Client } from '@df/core/service/client';
import { DfModuleImageModule } from '@df/module-image/df-module-image.module';
import { AttributeLabelPipe } from '@df/ui/common/attribute-label.pipe';
import { OptionLabelPipe } from '@df/ui/common/option-label.pipe';
import { DfUiModule } from '@df/ui/df-ui.module';
import { PriceComponent } from '@df/ui/price/price.component';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { TranslationService } from '@df/ui/translation/translation.service';
import { ProductWishlistToggleComponent } from '../../../catalog/product/wishlist-toggle/product-wishlist-toggle.component';
import { InlineButtonComponent } from '../../../common/buttons/inline-button/inline-button.component';
import { ResultComponent } from '../../../common/result/result.component';
import { BasketItemQtyComponent } from '../../item-qty/basket-item-qty.component';

@Component({
    selector: 'basket-view-item',
    templateUrl: './basket-view-item.html',
    styleUrls: ['./basket-view-item.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        OptionLabelPipe,
        PriceComponent,
        ResultComponent,
        RouterModule,
        DfUiModule,
        TranslationModule,
        InlineButtonComponent,
        CommonModule,
        DfModuleImageModule,
        BasketItemQtyComponent,
        AttributeLabelPipe,
        ProductWishlistToggleComponent
    ]
})
export class BasketViewItemComponent extends BasketItemComponentDef {
    @Input()
    nonEditable = false;

    @Input()
    hideQty = false;

    @Input()
    hideRemove = false;

    protected client = inject(Client);

    /**
     * If using minibasket context
     */
    @Input()
    context?: 'basket' | 'minibasket' | 'checkout' | 'notice';

    private translationService = inject(TranslationService);

    /**
     * Options image sizes
     * first value is for mobile, and second for desktop
     */
    @Input()
    imageSize?: [number, number] = [100, 126];

    /**
     * Stock warning
     */
    get warning(): string | undefined {
        if (!this.isSalable) {
            return this.maxQty
                ? this.translationService.transform('Only % availble', this.maxQty)
                : this.translationService.transform('Out of stock');
        }
        return undefined;
    }

    protected get isMinibasket(): boolean {
        return this.context === 'minibasket';
    }
}
